module.exports = __webpack_public_path__ + "static/media/hiper_white.5a7a5eda.png";